import { Card } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { StrategySection } from './StrategySection';
import { BoardMembersSection } from './BoardMembersSection';
import { CEOSection } from './CEOSection';
import { OrganizationalStructureSection } from './OrganizationalStructureSection';
import { GeneralAssemblySection } from './GeneralAssemblySection';

export function ProfileSection() {
  return (
    <Tabs defaultValue="strategy" className="flex flex-col h-full" dir="rtl">
      <TabsList className="grid w-full grid-cols-5 gap-2 mb-6 flex-shrink-0 sticky top-0 bg-background z-10">
        <TabsTrigger value="strategy">الإستراتيجية</TabsTrigger>
        <TabsTrigger value="board">مجلس الإدارة</TabsTrigger>
        <TabsTrigger value="ceo">المدير التنفيذي</TabsTrigger>
        <TabsTrigger value="structure">الهيكل التنظيمي</TabsTrigger>
        <TabsTrigger value="assembly">الجمعية العمومية</TabsTrigger>
      </TabsList>

      <TabsContent value="strategy" className="m-0">
        <StrategySection />
      </TabsContent>

      <TabsContent value="board" className="m-0">
        <BoardMembersSection />
      </TabsContent>

      <TabsContent value="ceo" className="m-0">
        <CEOSection />
      </TabsContent>

      <TabsContent value="structure" className="m-0">
        <OrganizationalStructureSection />
      </TabsContent>

      <TabsContent value="assembly" className="m-0">
        <GeneralAssemblySection />
      </TabsContent>
    </Tabs>
  );
}
